var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagSwedish(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 36,
    viewBox: "0 0 50 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5278 36H45C48.0681 36 50 35.1538 50 31.4029V21.4616H21.5278V36ZM45.5 0.000231004H21.5278V14.5386H50V4.48612C50 3.01724 50.0419 2.0358 49 0.997148C47.9581 -0.0415088 46.9734 0.000231004 45.5 0.000231004ZM14.5833 0.000231004L4 0C2.5273 -4.12921e-07 2.04175 -0.0408416 1 0.996917C-0.041749 2.03467 0.00110453 3.01796 0 4.48612V14.5386H14.5833V0.000231004ZM0 21.4616V31.4029C0.00277778 35.151 1.93333 35.889 5 35.889L14.5833 36V21.4616H0Z",
    fill: "#006AA7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5278 0H14.5833V14.5384H0V21.4614H14.5833V35.9998H21.5278V21.4614H50V14.5384H21.5278V0Z",
    fill: "#FECC00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagSwedish);
export default __webpack_public_path__ + "static/media/flag-swedish.087ae77cbf59058f0bc69c06114758d5.svg";
export { ForwardRef as ReactComponent };